import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import moment from 'moment';
import EvaluationPopUp from './EvaluationPopUp';

import '../containers/Goal/Mygoal.css';
import Popup from './ConformationPopup/Popup';
import { checkRoleEvaluation, deleteGoal } from '../service/PerformanceAPI';
import { encryptStorage } from '../constant';

export default function MyGoal(props) {
    const navigate = useNavigate();
    const { state, search } = useLocation();

    let details = { role: '', roleId: '', week: 0, domain: '' };
    const [userDetails, setUserDetails] = useState(details);
    const [noData, setNoData] = useState(false);
    const [empId, setEmpId] = useState();
    const [employeeEvaluationPopUp, setEmpEvaluationPopUp] = useState(false);
    const [EvaluationStart, setEvaluationStart] = useState(false);
    const [propsIndividual, setPropsIndividual] = useState([]);
    const [propsteam, setPropsTeam] = useState([]);
    const [propsEmpEvaluation, setPropsEmpEvaluation] = useState([]);
    const [propsEvaluationId, setPropsEvaluationId] = useState();
    const [propsEvaluation, setPropsEvaluation] = useState({});
    const [customStartEvaluation, setcustomStartEvaluation] = useState(false);
    const [customEmpId, setcustomEmpId] = useState();
    const [customDomain, setcustomDomain] = useState();
    const [customEvaluationPeriod, setcustomEvaluationPeriod] = useState();
    const [View, setView] = useState(false);
    const [goalId, setGoalId] = useState(false);
    const [copyTo, setCopyTo] = useState(false);
    const [GoalName, setGoalName] = useState('');
    const [deleteGoalClicked, setdeleteGoalClicked] = useState(false);
    const [EmployeeEvaluationPopUp, setEmployeeEvaluationPopUp] = useState(false);
    const [EvaluationImage, setEvaluationImage] = useState('');
    const [EmpEvaluationHeading, setEmpEvaluationHeading] = useState('');
    const [breadcrumbsProfile, setBreadcrumbsProfile] = useState([]);

    useEffect(() => {
        userDetails.roleId = encryptStorage.getItem('employeeId');
        userDetails.role = encryptStorage.getItem('role');
        userDetails.domain = encryptStorage.getItem('department');

        if (props.Individual !== undefined && props.Individual !== null) setPropsIndividual(props.Individual);
        if (props.Team !== undefined && props.Team !== null) setPropsTeam(props.Team);
        if (props.evaluationPeriodId !== undefined && props.evaluationPeriodId !== null) setPropsEvaluationId(props.evaluationPeriodId);
        if (props.EmployeeEvaluation !== undefined && props.EmployeeEvaluation !== null) setPropsEmpEvaluation(props.EmployeeEvaluation);
        if (props.Evaluation !== null && props.Evaluation !== undefined) {
            if (Object.keys(props.Evaluation).length > 0) {
                setPropsEvaluation(props?.Evaluation);
            }
        }
        if (props.Individual !== undefined && props.Team !== undefined) {
            let check = props.Individual.length === 0 && props.Team.length === 0 ? setNoData(true) : setNoData(false);
        }
        // if (props.Custom !== undefined && props.Custom !== null) {
        //     props.Custom == true ? setcustomStartEvaluation(true) : setcustomStartEvaluation(false);
        // }
        if (props.CustomEmpId !== undefined && props.CustomEmpId !== null) setcustomEmpId(props.CustomEmpId);
        if (props.CustomDomain !== undefined && props.CustomDomain !== null) setcustomDomain(props.CustomDomain);
        if (props.CustomEvaluationPeriod !== undefined && props.CustomEvaluationPeriod !== null)
            setcustomEvaluationPeriod(props.customEvaluationPeriod);
        if (props.BreadCrumbsProfile !== undefined && props.BreadCrumbsProfile !== null) setBreadcrumbsProfile(props.BreadCrumbsProfile);
        if (props.View !== undefined && props.View !== null) {
            setView(true);
        }
    }, [props]);

    const EditGoal = async (id) => {
        let check = View ? navigate(`/goalform/${id}`, { state: { View: true, redirect: search, profileBreadcrumbs:breadcrumbsProfile } }) : null;
    };

    useEffect(() => {
        // if (encryptStorage.getItem('role') === 'Team Member') {
        let endDate = moment(propsEvaluation?.endDate).subtract(23, 'days').format('MM-DD-YY');
        if (moment().format('MM-DD-YY') === endDate) {
            setcustomStartEvaluation(true);
            checkTeamMember('Team Member', 23);
        } else {
            let endDate = moment(propsEvaluation?.endDate).subtract(21, 'days').format('MM-DD-YY');
            if (moment().format('MM-DD-YY') === endDate) {
                setcustomStartEvaluation(true);
                checkTeamMember('Team Member', 21);
                setEvaluationStart(true);
            } else if (propsEvaluation?.currentEvaluation == 1) {
                if (
                    propsEmpEvaluation[0]?.employee_grand_rating === '' &&
                    moment().format('MM-DD-YY') > moment(propsEvaluation?.endDate).subtract(21, 'days').format('MM-DD-YY')
                ) {
                    setcustomStartEvaluation(true);
                    setEvaluationStart(true);
                    let endDate = moment(propsEvaluation?.endDate).subtract(21, 'days').format('MM-DD-YY');

                    let days = moment().diff(moment(endDate), 'days');
                    // let days = moment([moment().format('YYYY'), moment().format('M'), moment().format('D')]).diff(
                    //     (moment([moment(endDate).format('YYYY'), moment(endDate).format('M'), moment(endDate).format('D')])), 'days')
                    checkTeamMember('Team Member', 0, days);
                } else if (moment().format('MM-DD-YY') > moment(propsEvaluation?.endDate).subtract(21, 'days').format('MM-DD-YY')) {
                    setcustomStartEvaluation(true);
                }
            } else if (propsEvaluation?.currentEvaluation == 0) {
                setcustomStartEvaluation(true);
            }
        }

        // }
    }, [propsEvaluation, propsEmpEvaluation]);

    const checkTeamMember = (roleCheck, dayCheck, overDue = 0) => {
        let check =
            roleCheck === 'Team Member' && dayCheck === 23
                ? setEmpEvaluationHeading('Evaluation period will be starting in 2 days.')
                : roleCheck === 'Team Member' && dayCheck === 21
                ? setEmpEvaluationHeading('Evaluation is started.Please provide your evaluation right now')
                : setEmpEvaluationHeading(
                      `Your evaluation period is overdue by ${overDue} days. Please provide your evaluation right now.`
                  );

        check =
            dayCheck === 23
                ? setEvaluationImage('Honeybee.svg')
                : dayCheck === 21
                ? setEvaluationImage('Evaluation-started.svg')
                : setEvaluationImage('Evaluation-Overdue.svg');

        // if (userDetails.role == 'Team Member' && propsEvaluation?.endDate) {
        if (propsEvaluation?.endDate) {
            if (propsEvaluation?.id == encryptStorage.getItem('CurrentEvaluationId')) {
                let endDate =
                    dayCheck === 0
                        ? moment().format('MM-DD-YY')
                        : moment(propsEvaluation?.endDate).subtract(dayCheck, 'days').format('MM-DD-YY');
                if (moment().format('MM-DD-YY') == endDate) {
                    let started = encryptStorage.getItem('EvaluationStartedMember');
                    if ((started == null || started == undefined) && started !== true) {
                        setEmployeeEvaluationPopUp(true);
                    }
                }
            }
        }
    };

    const GoalView = async (id) => {
        let role;
        if (
            customEmpId ? encryptStorage.getItem('employeeId') === customEmpId : encryptStorage.getItem('employeeId') === userDetails.roleId
        ) {
            role = 'Team Member';
        } else {
            let checkrole = await checkRoleEvaluation({ viewerId: encryptStorage.getItem('employeeId'), empId: customEmpId });
            if (checkrole.data.statusCode == 200) {
                role = checkrole.data.ResponseData === 'Manager' ? checkrole.data.ResponseData : 'Hr Manager';
            }
        }

        let obj = View ? { role: role, View: true, redirect: search, profileBreadcrumbs: breadcrumbsProfile } : { role: role };
        navigate(`/goalview/${id}`, { state: obj });
    };

    const goalDeleteClicked = async () => {
        let obj = {
            goalId: goalId,
        };
        let deleteInfo = await deleteGoal(obj);
        if (deleteInfo.data.ResponseData == 'Succcesfully deleted') {
            props.MyGoal(customEmpId);
        }
    };

    const startEvaluation = async () => {
        let role;
        if (
            customEmpId ? encryptStorage.getItem('employeeId') === customEmpId : encryptStorage.getItem('employeeId') === userDetails.roleId
        ) {
            role = 'Team Member';
        } else {
            let checkrole = await checkRoleEvaluation({ viewerId: encryptStorage.getItem('employeeId'), empId: customEmpId });
            if (checkrole.data.statusCode == 200) {
                role = checkrole.data.ResponseData === 'Manager' ? checkrole.data.ResponseData : 'Hr Manager';
            }
        }

        View && customEmpId === encryptStorage.getItem('employeeId')
            ? navigate('/performanceevaluation', {
                  state: {
                      redirect: search,
                      View: true,
                      empId: customEmpId,
                      evaluationPeriodId: customEvaluationPeriod,
                      Domain: customDomain,
                      role: role,
                  },
              })
            : View
            ? navigate('/performanceevaluation', {
                  state: {
                      redirect: search,
                      View: true,
                      empId: customEmpId,
                      evaluationPeriodId: customEvaluationPeriod,
                      Domain: customDomain,
                      role: role,
                  },
              })
            : navigate('/performanceevaluation', {
                  state: {
                      empId: userDetails.roleId,
                      evaluationPeriodId: propsEvaluationId,
                      Domain: userDetails.domain,
                      role: role,
                  },
              });
    };

    const closeCopyTo = (value, action) => {
        setCopyTo(value);
        if (action) {
            props.MyGoal(customEmpId);
            // employeeGoals(empId)
        }
    };

    return (
        <>
            {EmployeeEvaluationPopUp && !View ? (
                <EvaluationPopUp Image={EvaluationImage} ID={'EvaluationStartedMember'} Page={'button'} Heading={EmpEvaluationHeading} />
            ) : null}
            {copyTo ? (
                <EvaluationPopUp
                    hide={(value, action = false) => {
                        closeCopyTo(value, action);
                    }}
                    Page={'copyto'}
                    ID={'profile-Copyto'}
                    goalName={GoalName}
                    GoalId={goalId}
                />
            ) : null}
            <Popup
                deleteData={() => {
                    goalDeleteClicked();
                }}
            />
            <div className="tab-pane fade show active " id="mygoal" role="tabpanel" aria-labelledby="mygoal-tab">
                <ul className={View ? `list-unstyled mt-3` : `list-unstyled`}>
                    <li className={View ? `card profile-performance-card` : `my-2 bg-white goal-li-sty py-3 px-3`}>
                        <div className="d-flex justify-content-between border-none bg-white">
                            <div className="col-md-2 align-self-center">
                                <h6 className="bold-text font-15 right-arrow">Evaluation Period</h6>
                                <p className="mb-0 gray-text font-15 medium-text right-arrow">
                                    {moment(propsEvaluation.startData).format('MMM, YYYY')} -{' '}
                                    {moment(propsEvaluation.endDate).format('MMM, YYYY')}
                                </p>
                            </div>
                            <div className="col-md-2 align-self-center">
                                <h6 className="bold-text font-15">Self Evaluation </h6>
                                {(
                                    propsEmpEvaluation.length < 0 ? (
                                        <p className="mb-0 gray-text font-15 medium-text">Not Started</p>
                                    ) : (
                                        propsEmpEvaluation[0]?.employee_grand_rating !== undefined &&
                                        propsEmpEvaluation[0]?.employee_grand_rating !== '' &&
                                        propsEmpEvaluation[0]?.TeamMemberispublished !== '1'
                                    )
                                ) ? (
                                    <>
                                        <img
                                            src={
                                                !propsEmpEvaluation[0]?.employee_grand_rating
                                                    ? null
                                                    : propsEmpEvaluation[0]?.employee_grand_rating.includes('+')
                                                    ? `/Images/${propsEmpEvaluation[0]?.employee_grand_rating?.slice(0, -1)}_plus.png`
                                                    : propsEmpEvaluation[0]?.employee_grand_rating.includes('-')
                                                    ? `/Images/${propsEmpEvaluation[0]?.employee_grand_rating?.slice(0, -1)}_minus.png`
                                                    : null
                                            }
                                            className="emoji-sty"
                                            alt="excited-emoji"
                                        ></img>

                                        <span className="right-arrow font-18 tt-bold text-skyblue">
                                            {propsEmpEvaluation[0]?.employee_grand_rating}
                                        </span>
                                    </>
                                ) : propsEmpEvaluation[0]?.TeamMemberispublished === '1' ? (
                                    <p class="mb-0 text-yellow font-14 medium-text">Save as draft</p>
                                ) : (
                                    <p className="mb-0 gray-text font-15 medium-text">Not Started</p>
                                )}
                            </div>
                            <div className="col-md-2 align-self-center">
                                <h6 className="bold-text font-15">Manager Evaluation</h6>
                                {(
                                    propsEmpEvaluation.length < 0 ? (
                                        <p className="mb-0 gray-text font-15 medium-text">Not Started</p>
                                    ) : (
                                        propsEmpEvaluation[0]?.manager_grand_rating !== undefined &&
                                        propsEmpEvaluation[0]?.manager_grand_rating !== '' &&
                                        propsEmpEvaluation[0]?.Managerispublished !== '1'
                                    )
                                ) ? (
                                    <>
                                        <img
                                            src={
                                                !propsEmpEvaluation[0]?.manager_grand_rating
                                                    ? null
                                                    : propsEmpEvaluation[0]?.manager_grand_rating.includes('+')
                                                    ? `/Images/${propsEmpEvaluation[0]?.manager_grand_rating?.slice(0, -1)}_plus.png`
                                                    : propsEmpEvaluation[0]?.manager_grand_rating.includes('-')
                                                    ? `/Images/${propsEmpEvaluation[0]?.manager_grand_rating?.slice(0, -1)}_minus.png`
                                                    : null
                                            }
                                            className="emoji-sty"
                                            alt="excited-emoji"
                                        ></img>

                                        <span className="right-arrow font-18 tt-bold text-skyblue">
                                            {propsEmpEvaluation[0]?.manager_grand_rating}
                                        </span>
                                    </>
                                ) : (
                                    <p className="mb-0 gray-text font-15 medium-text">Not Started</p>
                                )}
                            </div>
                            <div className="col-md-2 align-self-center">
                                <h6 className="bold-text font-15">HR Evaluation</h6>

                                {(
                                    propsEmpEvaluation.length < 0 ? (
                                        <p className="mb-0 gray-text font-15 medium-text">Not Started</p>
                                    ) : (
                                        propsEmpEvaluation[0]?.status === undefined ||
                                        propsEmpEvaluation[0]?.status === 'pending' ||
                                        propsEmpEvaluation[0]?.status === ''
                                    )
                                ) ? (
                                    <p className="mb-0 gray-text font-15 medium-text"> Not Started </p>
                                ) : propsEmpEvaluation[0]?.status === 'Rejected' ? (
                                    <p className="mb-0 text-red font-14 medium-text">Rejected</p>
                                ) : propsEmpEvaluation[0]?.status === 'Approved' ? (
                                    <p className="mb-0 text-green font-14 medium-text">Approved</p>
                                ) : null}
                            </div>
                            <div
                                onClick={() => {
                                    let check = customStartEvaluation ? startEvaluation() : null;
                                    // startEvaluation()
                                }}
                                className="col-md-2 align-self-center text-center"
                            >
                                {View && userDetails.role == 'Manager' ? (
                                    propsEmpEvaluation[0]?.Managerispublished === '1' ? (
                                        <a
                                            className={
                                                customStartEvaluation
                                                    ? ' semibold-text font-15 text-decoration-none cursor '
                                                    : 'light-grayblue-text semibold-text font-15 text-decoration-none '
                                            }
                                        >
                                            Continue
                                            <img src="/Images/right-arrow.svg" className="right-arrow ps-2" />
                                        </a>
                                    ) : propsEmpEvaluation[0]?.status === 'Rejected' ? (
                                        <a
                                            className={
                                                customStartEvaluation
                                                    ? ' semibold-text font-15 text-decoration-none cursor '
                                                    : 'light-grayblue-text semibold-text font-15 text-decoration-none '
                                            }
                                        >
                                            Re-evaluate
                                            <img src="/Images/right-arrow.svg" className="right-arrow ps-2" />
                                        </a>
                                    ) : propsEmpEvaluation[0]?.status === 'Approved' ? (
                                        <a
                                            className={
                                                customStartEvaluation
                                                    ? ' semibold-text font-15 text-decoration-none cursor '
                                                    : 'light-grayblue-text semibold-text font-15 text-decoration-none '
                                            }
                                        >
                                            View
                                            <img src="/Images/right-arrow.svg" className="right-arrow ps-2" />
                                        </a>
                                    ) : propsEmpEvaluation[0]?.manager_grand_rating !== undefined &&
                                      propsEmpEvaluation[0]?.manager_grand_rating !== '' &&
                                      propsEmpEvaluation[0]?.employee_grand_rating !== undefined &&
                                      propsEmpEvaluation[0]?.employee_grand_rating !== '' ? (
                                        <a
                                            className={
                                                customStartEvaluation
                                                    ? ' semibold-text font-15 text-decoration-none cursor '
                                                    : 'light-grayblue-text semibold-text font-15 text-decoration-none '
                                            }
                                        >
                                            Edit
                                            <img src="/Images/right-arrow.svg" className="right-arrow ps-2" />
                                        </a>
                                    ) : propsEmpEvaluation[0]?.employee_grand_rating !== undefined &&
                                      propsEmpEvaluation[0]?.employee_grand_rating !== '' ? (
                                        <a
                                            className={
                                                customStartEvaluation
                                                    ? ' semibold-text font-15 text-decoration-none cursor '
                                                    : 'light-grayblue-text semibold-text font-15 text-decoration-none '
                                            }
                                        >
                                            Start Evaluation
                                            <img src="/Images/right-arrow.svg" className="right-arrow ps-2" />
                                        </a>
                                    ) : (
                                        <a
                                            className={
                                                customStartEvaluation
                                                    ? ' semibold-text font-15 text-decoration-none cursor '
                                                    : 'light-grayblue-text semibold-text font-15 text-decoration-none '
                                            }
                                        >
                                            Start Evaluation
                                            <img src="/Images/right-arrow.svg" className="right-arrow ps-2" />
                                        </a>
                                    )
                                ) : View && userDetails.role == 'Hr Manager' ? (
                                    propsEmpEvaluation[0]?.status === 'Rejected' &&
                                    propsEmpEvaluation[0]?.manager_grand_rating !== undefined &&
                                    propsEmpEvaluation[0]?.manager_grand_rating !== '' &&
                                    propsEmpEvaluation[0]?.Managerispublished !== 1 ? (
                                        <a
                                            className={
                                                customStartEvaluation
                                                    ? ' semibold-text font-15 text-decoration-none cursor '
                                                    : 'light-grayblue-text semibold-text font-15 text-decoration-none '
                                            }
                                        >
                                            Re-evaluate
                                            <img src="/Images/right-arrow.svg" className="right-arrow ps-2" />
                                        </a>
                                    ) : (
                                        <a
                                            className={
                                                customStartEvaluation
                                                    ? ' semibold-text font-15 text-decoration-none cursor '
                                                    : 'light-grayblue-text semibold-text font-15 text-decoration-none '
                                            }
                                        >
                                            Start Evaluation
                                            <img src="/Images/right-arrow.svg" className="right-arrow ps-2" />
                                        </a>
                                    )
                                ) : propsEmpEvaluation[0]?.TeamMemberispublished === '1' ? (
                                    <a
                                        className={
                                            customStartEvaluation
                                                ? ' semibold-text font-15 text-decoration-none cursor '
                                                : 'light-grayblue-text semibold-text font-15 text-decoration-none '
                                        }
                                    >
                                        Continue
                                        <img src="/Images/right-arrow.svg" className="right-arrow ps-2" />
                                    </a>
                                ) : (propsEmpEvaluation[0]?.manager_grand_rating === undefined ||
                                      propsEmpEvaluation[0]?.manager_grand_rating === '') &&
                                  propsEmpEvaluation[0]?.employee_grand_rating !== undefined &&
                                  propsEmpEvaluation[0]?.employee_grand_rating !== '' ? (
                                    <a
                                        className={
                                            customStartEvaluation
                                                ? ' semibold-text font-15 text-decoration-none cursor '
                                                : 'light-grayblue-text semibold-text font-15 text-decoration-none '
                                        }
                                    >
                                        Edit
                                        <img src="/Images/right-arrow.svg" className="right-arrow ps-2" />
                                    </a>
                                ) : propsEmpEvaluation[0]?.manager_grand_rating === undefined ||
                                  propsEmpEvaluation[0]?.manager_grand_rating === '' ? (
                                    <a
                                        className={
                                            customStartEvaluation
                                                ? ' semibold-text font-15 text-decoration-none cursor '
                                                : 'light-grayblue-text semibold-text font-15 text-decoration-none '
                                        }
                                    >
                                        Start Evaluation
                                        <img src="/Images/right-arrow.svg" className="right-arrow ps-2" />
                                    </a>
                                ) : propsEmpEvaluation[0]?.manager_grand_rating !== undefined &&
                                  propsEmpEvaluation[0]?.manager_grand_rating !== '' ? (
                                    <a
                                        className={
                                            customStartEvaluation
                                                ? ' semibold-text font-15 text-decoration-none cursor '
                                                : 'light-grayblue-text semibold-text font-15 text-decoration-none '
                                        }
                                    >
                                        View Evaluation
                                        <img src="/Images/right-arrow.svg" className="right-arrow ps-2" />
                                    </a>
                                ) : (
                                    <a
                                        className={
                                            customStartEvaluation
                                                ? ' semibold-text font-15 text-decoration-none cursor '
                                                : 'light-grayblue-text semibold-text font-15 text-decoration-none '
                                        }
                                    >
                                        Start Evaluation
                                        <img src="/Images/right-arrow.svg" className="right-arrow ps-2" />
                                    </a>
                                )}
                            </div>
                        </div>
                    </li>

                    {propsIndividual.length > 0
                        ? propsIndividual.map((goal) => {
                              return (
                                  <li className={View ? `card profile-performance-card mt-2` : `my-2 bg-white goal-li-sty py-3 px-3`}>
                                      <div className="d-flex justify-content-between border-none bg-white">
                                          <div className="col-md-3 d-flex align-self-center">
                                              <div className="d-block align-self-center">
                                                  <a className="text-deco-none">
                                                      <img src="/Images/orange-arrow.svg" alt="orange-arrow" className="me-2" />
                                                  </a>
                                              </div>
                                              <div
                                                  onClick={() => {
                                                      GoalView(goal.id);
                                                  }}
                                                  title={goal.goal_name}
                                                  className={
                                                      View
                                                          ? `d-block align-self-center text-truncate cursor`
                                                          : `d-block align-self-center cursor`
                                                  }
                                              >
                                                  <a className={`font-15 mb-0 bold-text mygoal-para`}>{goal.goal_name}</a>
                                              </div>
                                          </div>
                                          <div className="col-md-2 align-self-center">
                                              <div className="d-flex">
                                                  <div className="d-block align-self-center">
                                                      <img
                                                          src="/Images/logo-person-user-person-icon.jpg"
                                                          className="profile-pic"
                                                          alt="creator-name"
                                                      />
                                                  </div>
                                                  <div className="d-block align-self-center">
                                                      <p className="ms-3 mb-0 gray-text font-15 medium-text">{goal.assignedby}</p>
                                                  </div>
                                              </div>
                                          </div>
                                          <div className="col-md-1 align-self-center text-center">
                                              {goal.manager_rating == null ||
                                              goal.manager_rating == undefined ||
                                              goal.manager_rating == '' ? (
                                                  <span className="right-arrow bold-text font-15 tt-bold text-skyblue">-</span>
                                              ) : (
                                                  <>
                                                      <img
                                                          src={
                                                              !goal?.manager_rating
                                                                  ? null
                                                                  : goal?.manager_rating.includes('+')
                                                                  ? `/Images/${goal?.manager_rating?.slice(0, -1)}_plus.png`
                                                                  : goal?.manager_rating.includes('-')
                                                                  ? `/Images/${goal?.manager_rating?.slice(0, -1)}_minus.png`
                                                                  : null
                                                          }
                                                          className="emoji-sty"
                                                          alt="excited-emoji"
                                                      ></img>
                                                      <span className="right-arrow bold-text font-15 tt-bold text-skyblue">
                                                          {goal.manager_rating}
                                                      </span>
                                                  </>
                                              )}
                                          </div>
                                          <div className="col-md-2 d-flex align-self-center">
                                              <div className="d-block align-self-center">
                                                  <span className="semibold-text gray-text font-15 pe-2">{goal.progress}%</span>
                                              </div>
                                              <div className="d-block progress progress-style align-self-center">
                                                  <div
                                                      className="progress-bar progress-style"
                                                      role="progressbar"
                                                      style={{ width: `${goal.progress}%` }}
                                                      aria-valuenow={50}
                                                      aria-valuemin={0}
                                                      aria-valuemax={100}
                                                  />
                                              </div>
                                          </div>
                                          <div className="col-md-2 text-center align-self-center">
                                              <span className={`status-btn ${goal.color} font-14`}>{goal.status}</span>
                                          </div>
                                          {View && customEmpId !== encryptStorage.getItem('employeeId') ? (
                                              <div className="dropend me-4 align-self-center">
                                                  <button
                                                      type="button"
                                                      className="btn p-0 align-self-center kebab-btn-sty"
                                                      data-bs-toggle="dropdown"
                                                      aria-expanded="false"
                                                  >
                                                      <span>
                                                          <img src="/Images/kebab-icon.svg" className="kebab-size" />
                                                      </span>
                                                  </button>
                                                  <ul className="dropdown-menu optionboxsize shadow border-0">
                                                      {goal.status == 'Completed' || propsEvaluation?.currentEvaluation == 0 ? (
                                                          <>
                                                              <li
                                                                  onClick={() => {
                                                                      setCopyTo(true);
                                                                      setGoalId(goal.id);
                                                                      setGoalName(goal.goal_name);
                                                                  }}
                                                                  data-bs-toggle="modal"
                                                              >
                                                                  <a className="dropdown-item dditems semibold-text fontsize12 fontcolor-1 cursor">
                                                                      <span>
                                                                          <img className="pe-2 mb-2" src="/Images/pencil-icon.svg" />
                                                                      </span>
                                                                      Copy
                                                                  </a>
                                                              </li>
                                                          </>
                                                      ) : (
                                                          <>
                                                              <li
                                                                  onClick={() => {
                                                                      EditGoal(goal.id);
                                                                  }}
                                                              >
                                                                  <a className="dropdown-item dditems semibold-text fontsize12 fontcolor-1 cursor">
                                                                      <span>
                                                                          <img className="pe-2 mb-2" src="/Images/pencil-icon.svg" />
                                                                      </span>
                                                                      Edit
                                                                  </a>
                                                              </li>
                                                              <li
                                                                  data-bs-toggle="modal"
                                                                  data-bs-target="#logout"
                                                                  onClick={() => {
                                                                      setGoalId(goal.id);
                                                                      setEmpId(goal.emp_id);
                                                                  }}
                                                              >
                                                                  <a className="dropdown-item dditems semibold-text fontcolor-1 fontsize12 cursor">
                                                                      <span>
                                                                          <img className="pe-2" src="/Images/delete-bin-icon.svg" />
                                                                      </span>
                                                                      Delete
                                                                  </a>
                                                              </li>
                                                              <li
                                                                  onClick={() => {
                                                                      setGoalName(goal.goal_name);
                                                                      setCopyTo(true);
                                                                      setGoalId(goal.id);
                                                                  }}
                                                                  data-bs-toggle="modal"
                                                              >
                                                                  <a className="dropdown-item dditems semibold-text fontsize12 fontcolor-1 cursor">
                                                                      <span>
                                                                          <img className="pe-2 mb-2" src="/Images/pencil-icon.svg" />
                                                                      </span>
                                                                      Copy
                                                                  </a>
                                                              </li>
                                                          </>
                                                      )}
                                                  </ul>
                                              </div>
                                          ) : null}
                                      </div>
                                  </li>
                              );
                          })
                        : null}
                    {propsteam.length > 0
                        ? propsteam.map((goal) => {
                              return (
                                  <li className={View ? `card profile-performance-card mt-2` : `my-2 bg-white goal-li-sty py-3 px-3`}>
                                      <div className="d-flex justify-content-between border-none bg-white">
                                          <div className="col-md-3 d-flex align-self-center">
                                              <div className="d-block align-self-center">
                                                  <a className="text-deco-none">
                                                      <img src="/Images/orange-arrow.svg" alt="orange-arrow" className="me-2" />
                                                  </a>
                                              </div>
                                              <div
                                                  onClick={() => {
                                                      GoalView(goal.id);
                                                  }}
                                                  title={goal.goal_name}
                                                  className={
                                                      View
                                                          ? `d-block align-self-center text-truncate cursor`
                                                          : `d-block align-self-center cursor`
                                                  }
                                              >
                                                  <a className={`font-15 mb-0 bold-text mygoal-para`}>{goal.goal_name}</a>
                                              </div>
                                          </div>
                                          <div className="col-md-2 align-self-center">
                                              <div className="d-flex">
                                                  <div className="d-block align-self-center">
                                                      <img
                                                          src="/Images/logo-person-user-person-icon.jpg"
                                                          className="profile-pic"
                                                          alt="creator-name"
                                                      />
                                                  </div>
                                                  <div className="d-block align-self-center">
                                                      <p className="ms-3 mb-0 gray-text font-15 medium-text">{goal.assignedby}</p>
                                                  </div>
                                              </div>
                                          </div>
                                          <div className="col-md-1 align-self-center text-center">
                                              {goal.manager_rating == null ||
                                              goal.manager_rating == undefined ||
                                              goal.manager_rating == '' ? (
                                                  <span className="right-arrow bold-text font-15 tt-bold text-skyblue">-</span>
                                              ) : (
                                                  <>
                                                      <img
                                                          src={
                                                              !goal?.manager_rating
                                                                  ? null
                                                                  : goal?.manager_rating.includes('+')
                                                                  ? `/Images/${goal?.manager_rating?.slice(0, -1)}_plus.png`
                                                                  : goal?.manager_rating.includes('-')
                                                                  ? `/Images/${goal?.manager_rating?.slice(0, -1)}_minus.png`
                                                                  : null
                                                          }
                                                          className="emoji-sty"
                                                          alt="excited-emoji"
                                                      ></img>
                                                      <span className="right-arrow bold-text font-15 tt-bold text-skyblue">
                                                          {goal.manager_rating}
                                                      </span>
                                                  </>
                                              )}
                                          </div>
                                          <div className="col-md-2 d-flex align-self-center">
                                              <div className="d-block align-self-center">
                                                  <span className="semibold-text gray-text font-15 pe-2">{goal.progress}%</span>
                                              </div>
                                              <div className="d-block progress progress-style align-self-center">
                                                  <div
                                                      className="progress-bar progress-style "
                                                      role="progressbar"
                                                      style={{ width: `${goal.progress}%` }}
                                                      aria-valuenow={50}
                                                      aria-valuemin={0}
                                                      aria-valuemax={100}
                                                  />
                                              </div>
                                          </div>
                                          <div className="col-md-2 text-center align-self-center">
                                              <span className={`status-btn ${goal.color} font-14`}>{goal.status}</span>
                                          </div>
                                          {View && customEmpId !== encryptStorage.getItem('employeeId') ? (
                                              <div className="dropend me-4 align-self-center">
                                                  <button
                                                      type="button"
                                                      className="btn p-0 align-self-center kebab-btn-sty"
                                                      data-bs-toggle="dropdown"
                                                      aria-expanded="false"
                                                  >
                                                      <span>
                                                          <img src="/Images/kebab-icon.svg" className="kebab-size" />
                                                      </span>
                                                  </button>
                                                  <ul className="dropdown-menu optionboxsize shadow border-0">
                                                      {goal.status == 'Completed' || propsEvaluation?.currentEvaluation == 0 ? (
                                                          <>
                                                              <li
                                                                  onClick={() => {
                                                                      setCopyTo(true);
                                                                      setGoalId(goal.id);
                                                                      setGoalName(goal.goal_name);
                                                                  }}
                                                                  data-bs-toggle="modal"
                                                              >
                                                                  <a className="dropdown-item dditems semibold-text fontsize12 fontcolor-1 cursor">
                                                                      <span>
                                                                          <img className="pe-2 mb-2" src="/Images/pencil-icon.svg" />
                                                                      </span>
                                                                      Copy
                                                                  </a>
                                                              </li>
                                                          </>
                                                      ) : (
                                                          <>
                                                              <li
                                                                  onClick={() => {
                                                                      EditGoal(goal.id);
                                                                  }}
                                                              >
                                                                  <a className="dropdown-item dditems semibold-text fontsize12 fontcolor-1 cursor">
                                                                      <span>
                                                                          <img className="pe-2 mb-2" src="/Images/pencil-icon.svg" />
                                                                      </span>
                                                                      Edit
                                                                  </a>
                                                              </li>
                                                              <li
                                                                  data-bs-toggle="modal"
                                                                  data-bs-target="#logout"
                                                                  onClick={() => {
                                                                      setGoalId(goal.id);
                                                                      setEmpId(goal.emp_id);
                                                                  }}
                                                              >
                                                                  <a className="dropdown-item dditems semibold-text fontcolor-1 fontsize12 cursor">
                                                                      <span>
                                                                          <img className="pe-2" src="/Images/delete-bin-icon.svg" />
                                                                      </span>
                                                                      Delete
                                                                  </a>
                                                              </li>
                                                              <li
                                                                  onClick={() => {
                                                                      setGoalName(goal.goal_name);
                                                                      setCopyTo(true);
                                                                      setGoalId(goal.id);
                                                                  }}
                                                                  data-bs-toggle="modal"
                                                                  data-bs-target="#profile-Copyto"
                                                              >
                                                                  <a className="dropdown-item dditems semibold-text fontsize12 fontcolor-1 cursor">
                                                                      <span>
                                                                          <img className="pe-2 mb-2" src="/Images/pencil-icon.svg" />
                                                                      </span>
                                                                      Copy
                                                                  </a>
                                                              </li>{' '}
                                                          </>
                                                      )}
                                                  </ul>
                                              </div>
                                          ) : null}
                                      </div>
                                  </li>
                              );
                          })
                        : null}
                </ul>
                {noData ? (
                    <>
                        <div className="row justify-content-center">
                            <img src="/Images/nodatafound.png" alt="nodatafound" className="custom-width" />
                            <h2 className="tt-bold font-15 text-center margin-negative">No Goal Found</h2>
                        </div>
                    </>
                ) : null}
            </div>
        </>
    );
}
